export default "__VITE_ASSET__9a664306__"